import React from "react";
import styled from "styled-components";
import { centsToCurrencyString } from "../../../utils/numbers";

const Item = styled.div`
    margin-bottom: 2em;

    &:last-child { margin-bottom: 0; }
`;

const ItemHead = styled.p`
    margin: 0 0 1em;

    &:last-child { margin-bottom: 0; }
`;

const ItemName = styled.span`
    font-weight: 700;
`;

const Configs = styled.p`
    font-size: 0.83em;
    margin: 0;
`;

function ConfirmationCandybarInfo({data}) {
    if (!data || !data.summary || !data.summary.length) {
        return null;
    }

    return <div className="confirmation-info-block">
        {data.summary.map(item => <Item>
            <ItemHead className="confirmation-info-row">
                <ItemName>{item.name}</ItemName>
                {item.price ? centsToCurrencyString(item.price) : ''}
            </ItemHead>
            {item.configs.length > 0 && <Configs>
                {item.configs.map(config => <span>
                    {config.options && config.options.map(option => <React.Fragment>
                        {config.name}: {option.name}
                        {option.subConfigs && option.subConfigs.map(subConfig => <React.Fragment>
                            <br/>
                            {subConfig.name}:
                            {' '}
                            {subConfig.options.map(option => option.name).join(', ')}
                        </React.Fragment>)}
                        <br/>
                    </React.Fragment>)}
                </span>)}
            </Configs>}
        </Item>)}
    </div>;
}

export default ConfirmationCandybarInfo;